import moment from 'moment';

// const TIMEZONE = 'Asia/Kolkata';

export function FormatDate(date, format = 'DD-MMM-YYYY') {
	return moment(date).local().format(format);
}

export function FormatTime(time, format = 'hh:mm:ss') {
	return moment(time).local().format(format);
}

export function FormatDateTime(datetime, format = 'DD-MMM-YYYY hh:mm`A', isutc = true) {
	const date = moment.utc(datetime);
	let fmt_date = date.format(format);
	if (isutc) {
		fmt_date = date.utcOffset(+330).format(format);
	}
	return fmt_date;
}
